export class ReconciliationLayout {
	public sections = [
		{
			title: 'Indicated Value',
			items: [
				[
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVSalesComparisonValueIndicatedBySalesComparisonApproachAmount',
							displayType: 'currency'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisValueIndicatedByCostApproachAmount',
							displayType: 'currency'
						}
					},
					{
						cssClass: 'col-md-4',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVIncomeAnalysisValueIndicatedByIncomeApproachAmount',
							displayType: 'currency'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVReconciliationSummaryComment'
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVValuationAdditionalComments'
						}
					}
				]
			]
		},
		{
			title: 'Appraisal Conditions',
			items: [
				[
					{
						cssClass: 'col-md-6',
						type: 'static-table',
						options: {
							header: [
								{
									label: 'This appraisal is made',
									colSpan: 2
								},
							],
							rows: [
								{
									cols: [
										{
											options: { label: 'As Is' }
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVReconciliationConditionOfAppraisalAsIs',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: {
												label: 'Subject to completion per plans and specifications on the basis of a hypothetical ' +
														'condition that the improvements have been completed'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVReconciliationConditionOfAppraisalSubjectToCompletion',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: {
												label: 'Subject to the following repairs or alterations on the basis of a hypothetical condition ' +
														'that the repairs or alteration have been completed'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVReconciliationConditionOfAppraisalSubjectToRepairs',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{
											options: {
												label: 'Subject to the following required inspection based on the extraordinary assumption that the ' +
														'condition or deficiency does not require alteration or repair'
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVReconciliationConditionOfAppraisalSubjectToInspections',
												displayType: 'bool',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
							]
						}
					},
					{
						cssClass: 'col-md-6',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVReconciliationConditionsComment'
						}
					},
				]
			]
		},
		{
			title: 'Appraised Value',
			items: [
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyAppraisedValueAmount',
							cssClass: 'big',
							displayType: 'currency',
							show: {
								label: false
							}
						}
					}
				],
				[
					{
						cssClass: 'col-md-12',
						type: 'composite-text',
						options: {
							text: 'Based on a complete visual inspection of the interior and exterior areas of the subject property, defined scope of work, ' +
								'statement of assumptions and limiting conditions, and appraiser\'s certification, my (our) opinion of the market value, as ' +
								'defined, of the real property that is the subject of this report is: {*}, as of {*}, which is the date of inspection and the ' +
								'effective date of this appraisal.',
							fields: [
								{
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVPropertyAppraisedValueAmount',
										cssClass: 'd-inline-block',
										displayType: 'currency',
										show: {
											label: false
										}
									}
								},
								{
									options: {
										path: 'CV_EXTENSION_SECTION.FIELDS.CVAppraisalEffectiveDate',
										cssClass: 'd-inline-block',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		}
	];
}
